module.exports = __webpack_public_path__ + "img/cattunnel37.b7d08230.jpg";